<template>
  <section class="infoVacSection container">
    <h2>Lugares de Vacunación</h2>
    <h5>Vacunatorio Central: de Lunes a Viernes de 7:30 a 18:00 horas. Av. España 587 norte, Capital.</h5>

    <h5>•	Zona Sanitaria I</h5>
    <p>
      <b>Lunes a Viernes - De 7:00 a 13:00 Hs</b> Ruiz Aguilar - José Ruiz - San Patricio - Mariano Moreno - Francisco González – Calcuta - Costanera Norte - Humberto Mira - Villa Observatorio - Villa María
    </p>
    <p>
      <b>De Lunes a Viernes - De 7:00 a 19:00 Hs</b> Las Margaritas – Carrillo – Comandante Cabot- Baez Laspiur - Villa Marini Bouthery - De La Colina - Barassi - Grillo - Ibone Silva
    </p>

    <h5>•	Zona sanitaria II</h5>

    <h6>Caucete</h6>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs</b> Hospital César Aguilar</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs</b> Centros de Salud: Vallecito, Las Talas, Centros de Salud Roscelli, Centros de Salud Alonso Fuego, Centros de Salud Virgen de Guadalupe, Centros de Salud B° Pie de Palo, Centros de Salud Virgen de la Paz, Pozo de los Algarrobos CAPS Pie de Palo</p>
    <p><b>Lunes a viernes de 8:00 a 12:00hs - sábados y domingo de 8:00 a 17:00hs</b>, Centro de Salud Marayes y Bermejo</p>

    <h6>25 de Mayo</h6>
    <p><b>Lunes a viernes de 8:00 a 12:00 hs./ 14:00 a 18:00hs</b> Hospital 25 de Mayo.</p>
    <p><b>Lunes a viernes de 8:00 a 12:00 hs</b> Centros de Salud Chimbera, El Encon, Domingo Cejas, Tupelí, Villa la Salud</p>

    <h6>San Martín</h6>
    <p><b>Lunes a viernes de 7:00 hs a 13 :00hs</b> - Hospital Stella Molina.</p>
    <p><b>Lunes a viernes de 7:00 hs a 13 :00hs</b> Centro de Salud Janssen, Centro de Salud Independencia, Centro de Salud Cordeo y Centro de Salud Ejército de los Andes</p>

    <h6>Valle Fértil</h6>
    <p><b>Lunes a viernes de 8:00 a 13:00 hs y de 14:00 a 19:00</b> - Hospital Dr. Alejandro Albarracín.</p>
    <p><b>Lunes a viernes de 8:00 a 13:00 hs.</b>Centro de Salud Astica</p>

    <h6>Angaco</h6>
    <p><b>Lunes a viernes de 7:00 a 16:00 hs.</b> Hospital Rizo Esparza.</p>
    <p><b>Lunes a viernes de 7:30 a 13:00 hs.</b>Centros de Salud El Bosque, CAPS Las Tapias, CAPS Campo de Batalla</p>

    <h5>•	Zona sanitaria III</h5>

    <h6>Albardón</h6>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs.</b> CIC La Laja, CIC Campo Afuera, Las Lomitas, El Rincón:</p>
    <p><b>Lunes a viernes de 8:00 a 12:00 hs.</b>La Cañada</p>
    <p><b>Lunes a viernes. 7:00 a 18:00hs y Sábado de 7:00 a 12:00 hs.</b>Hospital Dr. José Giordano</p>
    <p><b>Lunes a Viernes de 7:00 a 13:00 horas</b> CAPS El Rincón, CAPS La Cañada de Sarmiento , CAPS Las Lomitas , CIC La Laja: La Laja y Nacional , Posta Sanitaria las Tierritas</p>

    <h6>Jáchal</h6>
    <p><b>Lunes a viernes 7:00 a 13:00hs</b> - Hospital Buenaventura Luna:</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs./ sáb. de 8:00 a 12:00 hs</b> Hospital San Roque</p>
    <p><b>Lunes, miércoles, jueves y viernes, de 7:00 a 13:00 hs.</b> CAPS Gran China</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs</b> CAPS Tamberías</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs</b> CIC Niquivil</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs</b> CAPS Mogna</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs.</b> CAPS San Isidro</p>
    <p><b>Lunes a viernes de 8:00 a 12:30 hs.</b> CAPS La Represa</p>
    <p><b>Martes de 8:00 a 13:00 hs</b> Posta 3 Esquinas, Posta Árbol Verde, Posta Entre Ríos, Posta San Roque</p>

    <h6>Iglesia</h6>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs.</b> Hospital Dr. T. Perón:</p>
    <p><b>Lunes a viernes de 7:00 a 13:00hs.</b> CAPS Bella Vista, CIC Las Flores, CAPS Héroes de Malvinas, CAPS Enfermero Mery, CAPS Tudcum, CAPS Sub. ARA San Juan</p>

    <h5>•	Zona sanitaria IV</h5>
    <h6>Rivadavia</h6>

    <p><b>Lunes a Viernes de 13:00 a 19:00 horas</b> Hospital Marcial Quiroga- Vacunatorio, ubicado en Consultorios Externos.</p>
    <p><b>Lunes a viernes de 8:00 a 17:00 hs - Sáb. 9:00 a 12:00 hs</b> CS San Justo y CS La Bebida</p>
    <p><b>Lunes a viernes de 8:00 a 17:00 hs - Sáb. 9:00 a 12:00 hs</b> CS Rene Favaloro, CS Rodríguez Pinto y CAPS Rivadavia Norte</p>
    <p><b>Lunes a sábados de 8:00 a 12:00 hs</b> CS Aramburu, CAPS Lote 53 , CAPS Docentes Sanjuaninos y Dominga Raimunda</p>
    <p><b>Lunes a viernes de 8:00 a 17:00 hs. /Sáb. 9:00 a 11:00 hs</b> CAPS Lote 3</p>
    <p><b>Lunes a sábado de 8:00 a 12:00hs</b>: Hospital General Dra. Julieta Lanteri</p>

    <h6>Zonda</h6>
    <p><b>Lunes a viernes de 8:00 a 12:00/14:00 a 16:00 hs.</b> CAPS Zonda</p>

    <h6>Ullum</h6>
    <p><b>Lunes a Viernes 8:00 a 12:00/14:00 a 16:00 hs.</b>CIC Ullum y CAPS Royón</p>

    <h6>Calingasta</h6>
    <p><b>Lunes a viernes de 8:00 a 12:00 hs.</b> Hospital Aldo Cantoni y Centro de Salud Tambarías</p>
    <p><b>Lunes a viernes 8:00 a 13:00 hs.</b> Hospital de Barreal</p>

    <h5>•	Zona Sanitaria V</h5>

    <h6>Rawson</h6>
    <p><b>Lunes a viernes de 7:30 a 19:00hs. Sábados de 8:00 a 12:00 hs.</b> Centro Adiestramiento René Favaloro</p>
    <p><b>Lunes a viernes de 7:30 a 13:00 hs.</b> Capitán Lazo, Elio Cantoni, CIC Villa Angélica, CIC Médano de Oro, Bubica, Colonia Rodas, 12 de Octubre, Cristo Rey</p>
    <p><b>Lunes a viernes de 7:00 a 18:00 hs /Sáb. de 7:00 a 12:00 hs</b> CS Valle Grande, CIC Villa Krause y CS Río Blanco</p>

    <h6>Pocito</h6>
    <p><b>Lunes a viernes de 7:30 a 17:00hs. Sáb. de 8:00 a 11:30 hs</b> Hospital Federico Cantoni</p>
    <p><b>Lunes a sábado de 8:00 a 12:00 hs</b> CAPS V° Huarpes, CIC Pocito, CAPS V° Constitución, CAPS Alonso Fuego, CAPS Joaquín Uñac, CAPS Barrio Chubut</p>
    <p><b>Martes y Jueves de 8:00 a 12:00 hs</b> CAPS V° Paolini</p>
    <p><b>Lunes a viernes de 8:00 a 12:00 hs</b> CAPS Lote Hogar 27 y CAPS Barrio Municipal</p>
    <p><b>Lunes a Viernes de 8:00 a 17:00 hs. Sáb. 8:00 a 12:00 hs</b> CAPS Aldo Hermosilla</p>

    <h6>Sarmiento</h6>
    <p><b>Lunes a viernes 7 a 18 hs- sábado de 8 a 12 hs</b> Hospital Ventura Lloveras y Microhospital Los Berros</p>
    <p><b>Lunes a viernes de 7:00 a 13:00 hs.</b> Todos los CAPS del departamento</p>

  </section>
</template>

<style>
  .infoVacSection{
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  h2{
    text-align: center;
    margin-bottom: 10px !important;
  }
  h5{
    margin-top: 30px !important;
  }
  h6{
    margin-top: 17px;
  }
  p{
    margin: 3px !important;
  }
</style>